import * as Types from "../constants/Client";
import { ViewState } from "redux/constants/App";
import { setBusy, setError, setReady } from "./utils";

const initialState = {
    clients: [],
    error: {
        status: null,
        message: null,
        errors: [],
    },
    client: {
        id: null,
        name: null,
        employee_number: null,
        table_benefits: null,
        employee_regime: null
    },
    postStatus: ViewState.IDLE,
    getStatus: ViewState.IDLE,
    getIdStatus: ViewState.IDLE,
}

const actions = {

    [Types.ADD_CLIENT]: (state) => setBusy({ state, statusKey: "postStatus" }),
    [Types.ADD_CLIENT_OK]: (state) => setReady({ state, statusKey: "postStatus" }),
    [Types.ADD_CLIENT_FAILED]: (state, error) => setError({ state, statusKey: "postStatus", error }),

    [Types.FETCH_CLIENTS]: (state) => setBusy({ state, statusKey: "getStatus" }),
    [Types.FETCH_CLIENTS_FAILED]: (state, error) => setError({ state, statusKey: "getStatus", error }),
    [Types.FETCH_CLIENTS_OK]: (state, clients) => setReady({ state, statusKey: "getStatus", payload: { clients } }),

    [Types.FETCH_CLIENT_ID]: (state) => setBusy({ state, statusKey: "getIdStatus" }),
    [Types.FETCH_CLIENT_ID_FAILED]: (state, err) => setError({ state, statusKey: "getIdStatus", error: err }),
    [Types.FETCH_CLIENT_ID_OK]: (state, client) => setReady({ state, statusKey: "getIdStatus", payload: { client } }),

    [Types.PATCH_CLIENT]: (state) => setBusy({ state, statusKey: "postStatus" }),
    [Types.PATCH_CLIENT_OK]: (state) => setReady({ state, statusKey: "postStatus" }),
    [Types.PATCH_CLIENT_FAILED]: (state, error) => setError({ state, statusKey: "postStatus", error }),

    [Types.RESET_CLIENT]: (_) => Object.assign({}, initialState)

}

export default function (state = initialState, { type: actionType, payload }) {
    const action = actions[actionType];
    if (action) return action(state, payload);
    return state;
}